import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';

import { MeAvise } from '@app/models/me-avise';
import { ParticipanteService } from '@app/services/participante.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ProcessoService } from '@app/services/processo.service';
import { format } from 'date-fns';
import { MeAviseService } from '@app/services/meavise.service';

@Component({
  selector: 'app-mov-me-avise-prazo',
  templateUrl: './mov-me-avise-prazo.component.html',
  styleUrls: ['./mov-me-avise-prazo.component.scss']
})
export class MovMeAvisePrazoComponent implements OnInit {

  @Input() prazos: MeAvise[];
  @Input() lstUsuarios: IdDescricao[];
  @Output() modificaNomeAdvogado = new EventEmitter();
  @Input() editar = false;
  @Input() form = false;
  @Input() processoArquivado: boolean = false;
  cdsMask: CDSMask = new CDSMask();
  podeEditarPrazoMeAvise = false;
  exibir = false;
  podeVisualizarCampoPrazo = false;
  dataPublicacao: string;

  @Input() exibirAtalhos = false;
  @Output() atalhoPz = new EventEmitter();
  @Output() atalhoED = new EventEmitter();
  @Output() atalhoREC = new EventEmitter();
  @Output() atalhoCR = new EventEmitter();

  constructor(
    private _processoService: ProcessoService,
    private _participanteService: ParticipanteService,
    private _meAviseService: MeAviseService
  ) { }

  ngOnInit() {
    this.obterPermissoes();

    if (this.form) {
      this.exibir = true;
    }

    this.dataPublicacao = this.prazos[0]?.Data;
  }

  exibirFormulario(event: Event) {
    event.preventDefault();
    this.exibir = !this.exibir;

    if (this.prazos.length === 0) {
      this.prazos.push(
        new MeAvise(new Date().toISOString().split('T')[0])
      );
    }
  }

  adicionar() {
    this.prazos.push(new MeAvise(this.dataPublicacao));
    this.focaCampoDataUltimoPrazo();
  }

  remover(index: number) {
    this.prazos.splice(index, 1);
    this.focaCampoDataUltimoPrazo(index);
  }

  focaCampoDataUltimoPrazo(index: number = -1): void {
    const stringUltimo = `prazo.Data${this.prazos.length - 1}`;
    const stringIndex = `prazo.Data${index === 0 ? 0 : index - 1}`

    window.setTimeout(
      () => document.getElementById(index === -1 ? stringUltimo : stringIndex).focus(),
      0
    );
  }

  calculaPrazo(i: number) {
    if (this.prazos[i].Data !== '') {
      this._processoService.calculaPrazo(this.prazos[i].Data, this.prazos[i].PrazoDias).subscribe(data => {
        this.prazos[i].Prazo = (data.data);
        this.prazos[i].PrazoInterno = data.dataInterno;
        this.prazos[i].PrazoFatal = data.dataFatal;
        //this.prazos[i].Descricao = data.dataInterno + ' '+ this.prazos[i].Descricao;
        this.prazos[i].Descricao = `PRAZO: ${format(new Date(data.data + 'T00:00:00'), 'dd/MM/yyyy')}`;
        //this.prazos[i].Descricao = "PRAZO: " + this.prazos[i].Prazo
      });
    }
  }

  respostaMudarAdvNome(advogado: any) {
    this.modificaNomeAdvogado.emit(advogado);
  }

  enviaAtalhoPZ(prazo: string) {
    if (prazo) {
      this.atalhoED.emit(prazo);
    }
  }

  enviaAtalhoED(prazo: string) {
    if (!prazo) {
      prazo = '';
    }
    this.atalhoED.emit('E.D. - ' + prazo);
  }

  enviaAtalhoREC(prazo: string) {
    if (!prazo) {
      prazo = '';
    }
    this.atalhoREC.emit('Rec. - ' + prazo);
  }

  enviaAtalhoCR(prazo: string) {
    if (!prazo) {
      prazo = '';
    }
    this.atalhoED.emit('C.R. - ' + prazo);
  }

  obterPermissoes() {
    if(this.editar) {
      this._obterPermissaoEditarPrazoMeAvise();
    }

    this._obterPermissaoVisualizarPrazoFatal();
  }

  private _obterPermissaoEditarPrazoMeAvise() {
    this._participanteService.verificaPermissaoUsuario(0, 'PodeEditarPrazoMeAvise')
      .subscribe(data => {
        this.podeEditarPrazoMeAvise = data;
      });
  }

  private _obterPermissaoVisualizarPrazoFatal() {
    this._meAviseService.obterPermissaoVisualizacaoPrazo()
      .toPromise().then((data: boolean) => {
        this.podeVisualizarCampoPrazo = data;
    });
  }

}
